import { Form, Field, FormElement, FieldWrapper } from '@progress/kendo-react-form';
import React, { useState, useEffect } from 'react';
import FormContainer from '../components/FormContainer';
import config from '../appconfig/config.json';
import Loading from '../components/Loading';
import acctDtlsData from '../data/acctdetailsdata.json';
import { useHistory } from 'react-router-dom';
import { CusFormLabel } from '../validation/Form-Components';
import { Button } from "@progress/kendo-react-buttons";
import imgpdfD from "../images/icon_pdf.png";
import imgPrint from "../images/icon_print.png";
import img from '../images/appComplete.png';
import img1 from '../images/smappComplete.png';
import storage from '../factory/StorageFactory';



const StatusComplete = (props) => {
    let timer;
    const detailsType = '1';

    const history = useHistory();


    const [branchObj, setBranchObj] = useState({ "value": "", "label": "", "addr": "" });

    const [isLoading, setIsLoading] = useState(false); //default true;

    const [isError, setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const [response, setResponse] = useState();

    const [accounts, setAccounts] = useState(acctDtlsData.resData.bankAccounts); //added dummy data, actual data should be from api

    const [acctDetails, setAcctDetails] = useState({
        PrefBranch: '',
        PrefAcct: ''
    })

    useEffect(() => {
        console.log('@StatusComplete useEffect');

        window.scrollTo(0, 0);
        getPropsData();

        return () => clearTimeout(timer);
    }, []);

    const getPropsData = () => {
        if(props.location.state !== undefined) { //not first time
            // console.log('UEN: ',props.location.state.uen)
            // console.log('NRIC: ',props.location.state.idNum)
        }
    }

    //bank branch selection
    const handlePrefBranch = (e) => {
        if (e.value === null) {
            return;
        }
        setBranchObj(e.value);
    }

    const handlePrefAccount = (e) => {
        if (e.value === null) {
            return;
        }
    }



    const handleSubmit = (dataItem) => {
        if (dataItem.isValid) {
            let data = JSON.parse(JSON.stringify(dataItem.values));
            goNext();
        }
    }

    const handleBack = (e) => {
        e.preventDefault();
        let sid = storage.getStateId();
        history.push(config.route.CompanyDetails + '?state=' + sid);
    }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout()
    }

    const setErrMsgTimeout = () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    const goNext = () => {
        if (history.location.state !== undefined) {
            if (history.location.state.from === config.route.Preview) {
                history.goBack();
            }
        }
        else {
            history.push(config.route.PersonDetails);
        }
    }

    if (isLoading) {
        return (
            <Loading />
        )
    }

    return (
        <div className="container-fluid">
            {/* <SubHeader title={'We have received your application.'} /> <br /> */}
            <div className="outerdivsubheader">
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <h2 className='completeTitle1 mb-0'>{'We have received your application.'}</h2>
                        <h2 className='completeTitle2'>{'You will receive an email/SMS to review and submit the application confirmation.'}</h2>
                    </div>

                </div>
            </div>

            <Form onSubmitClick={handleSubmit}
                initialValues={acctDetails}
                key={JSON.stringify(acctDetails)}
                render={(formRenderProps) => (
                    <FormElement>
                        <FormContainer>
                            <fieldset>
                                <div style={{ textAlign: 'center', padding: '20px' }}>
                                    <img className="imgScc" src={img1} alt="imgScc1"></img>
                                </div>
                            </fieldset>
                        </FormContainer>

                        <FormContainer>
                            <fieldset>
                                <div style={{ textAlign: 'center', padding: '20px' }}>
                                    <h2 style={{ color: 'orange', fontSize: '1.2em' }}>We will email and SMS you our decision soonest</h2><br />
                                    <img className="imgScc" src={img} alt="imgScc"></img><br />

                                    <div className="bbline">Application Complete</div><br />

                                    <div style={{ paddingTop: "1em" }}>Charlotte Chen</div>
                                </div>
                                <FieldWrapper>

                                    <div style={{ width: '100%', marginLeft: '-10px' }}>
                                        <hr className="hrgoldline" />
                                    </div>

                                    <Field component={CusFormLabel}
                                        leftLabelId={'lblAppNum'} leftLabelName={'Application Number'}
                                        id={'appNum'} name={'BTL02082021123456M2U'} />

                                    <Field component={CusFormLabel}
                                        leftLabelId={'lblUen'} leftLabelName={'UEN'}
                                        id={'uen'} name={'2103767890K'} />

                                    <Field component={CusFormLabel}
                                        leftLabelId={'lblFacility'} leftLabelName={'Facility'}
                                        id={'facility'} name={'Working Capital Loan'} />

                                    <Field component={CusFormLabel}
                                        leftLabelId={'lblFinanceType'} leftLabelName={'Financing Type'}
                                        id={'financeType'} name={'Conventional'} />

                                    <Field component={CusFormLabel}
                                        leftLabelId={'lblAmount'} leftLabelName={'Amount'}
                                        id={'amount'} name={'SGD 80,000'} />

                                    <Field component={CusFormLabel}
                                        leftLabelId={'lblTenure'} leftLabelName={'Tenure'}
                                        id={'tenure'} name={'3 Years'} />

                                    <Field component={CusFormLabel}
                                        leftLabelId={'lblInstalment'} leftLabelName={'Instalment'}
                                        id={'instalment'} name={'SGD 2.222'} />

                                    <Field component={CusFormLabel}
                                        leftLabelId={'lblInterestRate'} leftLabelName={'Interest Rate'}
                                        id={'interestRate'} name={'4.25%'} />

                                    <Field component={CusFormLabel}
                                        leftLabelId={'lblDate'} leftLabelName={'Date'}
                                        id={'date'} name={'07/07/2021'} />


                                    <div className="row" style={{ width: '100%', marginLeft: '-10px' }}>
                                        <hr className="hrgoldline" />
                                    </div>

                                    <div style={{ textAlign: 'center', paddingTop: '20px', paddingBottom: '20px' }}>

                                        <div className="sccbtMid">

                                            <Button look="outline" className="btPce2">
                                                <img className="img-fluid" src={imgpdfD} alt="imgpdfD"></img>
                                                &nbsp;&nbsp;Save this PDF
                                            </Button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            <Button look="outline" className="btPce2 btRht2">
                                                <img className="img-fluid" src={imgPrint} alt="imgPrint"></img>
                                                &nbsp;&nbsp;Print this
                                            </Button>
                                        </div><br /><br />

                                        <div className="row around-xs inputPair elementVisible">
                                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <button type={'submit'} className="k-button btn btn-success" disabled={!formRenderProps.valid}>{'Back To Home'}</button>
                                            </div>
                                        </div>
                                        To cancel the Application. <a style={{ color: 'blue' }}><u>Click here</u></a>

                                    </div>


                                </FieldWrapper>
                                <FieldWrapper></FieldWrapper>
                            </fieldset>
                        </FormContainer>

                        <FieldWrapper></FieldWrapper>
                    </FormElement>
                )}>

            </Form>
        </div>
    )
}

export default StatusComplete;